<template>
    <div class="wrap">
        <!-- <div class="download" @click="printPdf">下载价格表</div> -->
        <div style="width: 100%; height: 48px"></div>
        <div class="header_title">
            <div class="header_center">
                <div class="title">
                    申报项目:
                    <span>{{ $route.query.title }}</span>
                </div>
                <div style="display: flex" v-if="is_view != 1">
                    <div class="back_page" @click="close">关闭预览</div>
                    <div class="toexamine" @click="sumbittoexamine">
                        <img src="../../assets/19178@2x.png" alt/>
                        <p>提交审核</p>
                    </div>
                    <div class="toexamine" @click="downloadfile">
                        <p>下载文件</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="header_title" v-if="states == '审核'">
            <div class="header_center">
                <div class="title">
                    您正在评审:<span>{{ user.name }}</span> <span>{{ $route.query.title }}</span>的评审材料
                    <div class="info">
                        申报序号:
                        <span>{{ id }}</span>
                        <span>申报于：{{ created_at.slice(0, 10) }}</span>
                    </div>
                </div>


                <div style="display: flex" v-if="$route.query.is_show_btn == 1">
                    <div class="toexamine green" @click="Passtheaudit">
                        <img src="../../assets/19178@2x.png" alt/>
                        <p>通过审核</p>
                    </div>
                    <div class="toexamine borderred" @click="Disapproval">
                        <img src="../../assets/3.png" alt/>
                        <p>不予通过</p>
                    </div>
                </div>
                 <div style="display: flex" v-if="!$route.query.no_back">
                    <div class="toexamine green" @click="close">
                        <img src="../../assets/19178@2x.png" alt/>返回
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="填写不通过原因" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">
            <div class="yellow-box">
                <span>{{ id }}</span>
                <span>{{ user.name }}</span>
                <span>申请提交于{{ created_at }}</span>
            </div>
            <textarea class="reason" name="" id="" cols="30" rows="10" v-model="reason"
                      placeholder="点击输入无法通过审核的原因..."></textarea>
            <span slot="footer" class="dialog-footer">
          <el-button
              type="primary"
              icon="el-icon-check"
              @click="sumbit"
          >确认提交</el-button
          >
        </span>
        </el-dialog>
        <previeweproject
            id="previeweproject"
            v-if="JSON.stringify(alldata)!='{}'"
            :alldata="alldata"
        ></previeweproject>
    </div>
</template>

<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import {EprojectDeclareDetails, eprojectverify} from "../../utils/api";
import preview_eproject from "../word/preview_eproject";
import ImageModule from "docxtemplater-image-module-free";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import objmin from "./word_1.json";
import {EprojectDeclare,EDraftrecord} from "../../utils/api";

export default {
    components: {
        previeweproject: preview_eproject,
    },
    data() {
        return {
            id: '',
            vtid: '',
            reason: "",
            created_at: "",
            dialogVisible: false,
            alldata: {},
            otherFile: undefined,
            user: {},
            time: undefined,
            title: undefined,
            states: 1,
            exportPriceObj: objmin,
            xiahuaxian:
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
            is_view:0
        };
    },
    async created() {
        const { nav_title ,is_view,states,vtid} = this.$route.query
        if (nav_title) {
            document.title = nav_title
        }
        this.states = states;
        this.is_view = is_view;
        let res;
        if (this.$route.query.id) {
            console.log(this.$route.query.id)
            console.log("title:", this.$route.query.title)
            res = await EprojectDeclareDetails(this.$route.query.id);
            sessionStorage.setItem("parameters_time", res.created_at);
            console.log("res:", res)
            this.time = res.created_at
            this.title = this.$route.query.title
            
            if(this.is_view != 1 && this.states != '审核'){
                 rtmp = await EDraftrecord(res.project_id, res.project_batch_id);
                console.log("get data", res, sessionStorage.getItem("parameters_time"))
                this.alldata = rtmp;
                this.created_at = rtmp.created_at
            } else {
                this.alldata = res;
                this.created_at = res.created_at
            }
           
            
            this.id = res.id
            
            if (res.user) {
                this.user = res.user
            }
        } else {
            this.alldata = JSON.parse(sessionStorage.getItem("ruleForm"));
            this.time = sessionStorage.getItem("parameters_time");
            console.log(sessionStorage.getItem("ruleForm"))
            console.log(this.time)
        }
    },
    methods: {
        //通过审核
        Passtheaudit() {
            console.log(this.id);
            let data = {
                status: 1
            }
            eprojectverify(data, this.id).then(res => {
                this.$message({
                    message: "审核成功",
                    type: "success",
                })
                this.$router.go(-1)
            }).catch(error => {
                this.$message({
                    message: error,
                    type: "warning",
                })
            })
        },
        //不予通过
        Disapproval() {
            this.dialogVisible = true
        },
        sumbit() {
            if (this.reason == "") {
                this.$message.error('请填写不通过原因')
                return false
            }
            let data = {
                status: 0,
                content: this.reason
            }
            eprojectverify(data, this.id).then(res => {
                this.$message({
                    message: "提交成功",
                    type: "success",
                })
                this.$router.go(-1)
            }).catch(error => {
                this.$message({
                    message: error,
                    type: "warning",
                })
            })
            this.dialogVisible = false;
        },
        handleClose(done) {
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => {
                });
        },
        downloadfile() {
            let targetDom;
            targetDom = document.querySelector("#previeweproject").children[0];
            //targetDom.children[1].children[0].children[1].children[0].setAttribute("crossOrigin", 'Anonymous')
            //console.log(targetDom.children[1].children[0].children[1].children[0])
            
            let _this = this;
            this.$nextTick(() => {
                // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
                html2Canvas(targetDom, {
                    allowTaint: true,
                    useCORS: true
                    //foreignObjectRendering: true
                }).then(function (canvas) {
                    // 通过promise返回canvas元素
                    let contentWidth = canvas.width;
                    let contentHeight = canvas.height;
                    let pageHeight = (contentWidth / 592.28) * 841.89; // 每页高度：a4纸的尺寸
                    let leftHeight = contentHeight;
                    let position = 0;
                    let imgWidth = 590.28; // 图片宽度
                    let imgHeight = (592.28 / contentWidth) * contentHeight;
                    let context = canvas.getContext("2d");
                    context.scale(2, 2);
                    let pageData = canvas.toDataURL("image/jpeg", 1.0); // 保存canvas图像
                    // 参数：方向（l：横向，p：纵向）| 测量单位（"pt"，"mm", "cm", "m", "in" or "px"）| 格式（默认a4，也可通过大小数组[595.28, 841.89]）
                    let PDF = new JsPDF("p", "pt", "a4");
                    // 按照a4规格分页操作
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage(); // 添加页
                            }
                        }
                    }
                    PDF.save(_this.$route.query.title + ".pdf"); // 保存pdf文档，本地下载pdf文件
                });
            });
        },
        async sumbittoexamine() {
            if (this.$route.query.issumbit == 'false') {
                this.$message.warning('请填写完表单在进行提交')
                return false
            }
            console.log("提交")
           
            EprojectDeclare(this.$route.query.projectid, this.alldata, this.id, this.$route.query.projectbatchid)
                    .then((res) => {
                        this.$message.success('提交成功')
                        this.$router.push("/member/eprojectdeclear?name=申报专家");
                        //this.$router.go(-1);
                    })
                    .catch((err) => {
                        console.log('submit err',err)
                        this.$message.error(err)
                    })


        },
        close() {
            if(this.$route.query.vtid){
                this.$router.push("/epform?title=专家申请&id="+this.$route.query.projectid+"&project_batch_id="+this.$route.query.projectbatchid+"&vtid="+this.$route.query.vtid);
                
            } else {
                this.$router.go(-1);
            }
            
        },
        printPdf() {
            this.$easyPrint("exportPdf", "我的文件", "portrait");
        },
        beforeRouteLeave(to, from, next){ // 列表页面跳转到 详情页时，设置需要缓
            next()
          }
    },
};
</script>

<style lang="less" scoped>
.wrap {
    width: 100%;
    background: #eff3f8;

    .textarea {
        width: 382px;
        // height: 92px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
    }

    .reason {
        margin-top: 20px;
        width: 100%;
        height: 162px;
        background: #FFFFFF;
        border: 1px solid #BDC3CB;
        opacity: 1;
        border-radius: 4px;
        outline: none;
        padding: 10px;
        box-sizing: border-box;
    }

    .yellow-box {
        height: 40px;
        background: #FEF8EF;
        opacity: 1;
        border-radius: 6px 6px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        span {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 24px;

            &:nth-child(1) {
                color: #194ABE;
            }

            &:nth-child(2) {
                color: #0C0D0F;
            }

            &:nth-child(3) {
                color: #7C828A;
                font-size: 14px;
            }
        }
    }

    //   顶部title样式
    .header_title {
        top: 0;
        position: fixed;
        width: 100%;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 6px 12px rgba(0, 17, 58, 0.06);
        z-index: 999;

        .header_center {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            padding: 10px 0;
            justify-content: space-between;
            align-items: center;

            .title {
                font-size: 20px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                line-height: 29px;
                color: #0c0d0f;
                text-align: start;

                span {
                    font-size: 22px;
                    line-height: 32px;
                    color: #194abe;
                }
            }

            .info {
                span {
                    margin-right: 10px;

                    &:nth-child(1) {
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        line-height: 24px;
                        color: #0c0d0f;
                    }

                    &:nth-child(2) {
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        line-height: 24px;
                        color: #194abe;
                    }

                    &:nth-child(3) {
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        line-height: 20px;
                        color: #7c828a;
                    }
                }
            }

            .toexamine {
                cursor: pointer;
                width: 161px;
                height: 37px;
                background: #194abe;
                opacity: 1;
                border-radius: 4px;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 20px;

                img {
                    width: 18px;
                    height: 14px;
                    margin-right: 10px;
                    box-sizing: border-box;
                }
            }

            .green {
                background: #1abf98;
            }

            .borderred {
                width: 161px;
                height: 37px;
                background: #ffffff;
                border: 1px solid #f97e7e;
                opacity: 1;
                border-radius: 4px;
                color: #f97e7e;

                img {
                    width: 18px;
                    height: 18px;
                }
            }

            .back_page {
                cursor: pointer;
                width: 124px;
                height: 36px;
                background: #ffffff;
                border: 1px solid #c8cdd5;
                opacity: 1;
                border-radius: 6px;
                line-height: 36px;
                color: #7c828a;
            }
        }
    }

    .a4 {
        padding: 50px 60px 50px 60px;
        width: 842px;
        height: 1346px;
        margin: 0 auto;
        margin-top: 32px;
        background: #ffffff;
        box-sizing: border-box;
        color: black;
        box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.16);

        p,
        h1 {
            font-family: "仿宋";
        }

        .th {
            display: flex;
            align-items: center;
            font-family: "仿宋";
        }

        .box {
            box-sizing: border-box;
            border: 1px solid black;
            margin: 0 -1px -1px 0;
            text-align: center;
            font-size: 20px;
        }

        .position {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .word {
        text-align: center;
    }

    p {
        display: flex;
        justify-content: center;
    }

    table {
        text-align: center;
    }
}
</style>
